/* All ingredients — server-rendered list with search + A–Z filter.
   The detail drawer reuses the theme's <dra-wer> component (modal.js): we just
   populate it on open; open/close, overlay, ESC and click-outside are handled there. */
class AllIngredients extends HTMLElement {
  connectedCallback() {
    this.list = this.querySelector('[data-list]');
    this.search = this.querySelector('[data-search]');
    this.alphabet = this.querySelector('[data-alphabet]');
    this.letters = Array.from(this.querySelectorAll('[data-alphabet-letter]'));
    this.cards = Array.from(this.querySelectorAll('[data-item]'));
    this.noResults = this.querySelector('[data-no-results]');
    this.drawer = this.querySelector('#ingredient-drawer');
    this.drawerContent = this.querySelector('[data-drawer-content]');
    this.activeClass = 'all-ingredients__alphabet-item--active';
    this.activeLetter = '';

    this.sortCards();
    this.enableLetters();
    this.bind();
  }

  sortCards() {
    this.cards.sort((a, b) => (a.dataset.name || '').localeCompare(b.dataset.name || '', 'da'));
    this.cards.forEach((card) => this.list.insertBefore(card, this.noResults || null));
  }

  enableLetters() {
    const present = new Set(this.cards.map((c) => c.dataset.letter));
    this.letters.forEach((btn) => {
      btn.disabled = !present.has(btn.dataset.letter);
    });
  }

  bind() {
    let t;
    this.search.addEventListener('input', () => {
      clearTimeout(t);
      t = setTimeout(() => {
        this.clearActiveLetter();
        this.filter();
      }, 250);
    });

    this.alphabet.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-alphabet-letter]');
      if (!btn || btn.disabled) return;

      if (btn.dataset.letter === this.activeLetter) {
        this.clearActiveLetter();
      } else {
        this.search.value = '';
        this.activeLetter = btn.dataset.letter;
        this.letters.forEach((l) => l.classList.toggle(this.activeClass, l === btn));
      }
      this.filter();
    });

    this.querySelectorAll('[data-open]').forEach((btn) => {
      btn.addEventListener('click', () => this.openDrawer(btn.closest('[data-item]')));
    });
  }

  clearActiveLetter() {
    this.activeLetter = '';
    this.letters.forEach((l) => l.classList.remove(this.activeClass));
  }

  filter() {
    const q = this.search.value.trim().toLowerCase();
    const useIncludes = q.length > 2;
    let visible = 0;

    this.cards.forEach((card) => {
      let hit = true;

      if (this.activeLetter) {
        hit = card.dataset.letter === this.activeLetter;
      } else if (q) {
        const name = card.dataset.name || '';
        const sci = card.dataset.sci || '';
        const tags = card.dataset.tags || '';
        hit =
          (useIncludes ? name.includes(q) : name.startsWith(q)) ||
          (useIncludes ? sci.includes(q) : sci.startsWith(q)) ||
          (useIncludes && tags.includes(q));
      }

      card.hidden = !hit;
      if (hit) visible++;
    });

    if (this.noResults) this.noResults.hidden = visible !== 0;
  }

  openDrawer(card) {
    const tpl = card && card.querySelector('[data-detail]');
    if (!tpl || !this.drawer) return;
    this.drawerContent.innerHTML = '';
    this.drawerContent.appendChild(tpl.content.cloneNode(true));

    if (typeof this.drawer.openDrawer === 'function') {
      this.drawer.openDrawer();
    } else {
      this.drawer.setAttribute('open', ''); // fallback if modal.js hasn't upgraded yet
    }
  }
}

if (!customElements.get('all-ingredients')) {
  customElements.define('all-ingredients', AllIngredients);
}
